module.exports = __webpack_public_path__ + "img/jd.dad56cbe.jpg";